<template>
  <div class="control-manage_page">
    <control-left ref="left" @createTask="createTask" @editTask="editTask" @openDetail="openDetail"
      @deleteList="deleteList"></control-left>
    <!-- 右侧收缩栏 -->
    <control-right :selectedDeviceInfo="selectedDeviceInfo" ref="right" @closeRight="closeRight"
      @saveSuccess="saveSuccess" @deleteCamera="deleteCamera" @chooseCamera="chooseCamera"></control-right>
  </div>
</template>
<script>
import controlRight from "../components/control-right";
import controlLeft from "../components/control-left";
import { api } from "../api";
import { Dic } from "$utils";
export default {
  components: {
    controlLeft,
    controlRight,
  },
  data() {
    return {
      checkControlInfo: null, //布控记录详情
      deviceForm: {
        controlType: "1",
        controlFlag: "",
        deviceName: "",
      },
      typeOptions: Dic.find("SENU081"),
      devices: [], // 全部区域的摄像机信息集合
      devicesId: [], // 全部区域的摄像机信息ID集合
      selectedDeviceId: [], //地图上已选中的摄像机id集合
      selectedDeviceInfo: [], //地图上已选中的摄像机基本信息集合
      rightShow: false,
      typeMap: {},
      cameraId: "cameraId", //所有摄像机图层
    };
  },
  watch: {
    selectedDeviceId(newVal, oldVal) {
      this.selectedDeviceInfo = [];
      newVal.forEach((item, index) => {
        let curDeviceInfo = JSON.parse(
          JSON.stringify(this.devices[this.devicesId.indexOf(item)])
        );
        this.selectedDeviceInfo.push(curDeviceInfo);
      });
      console.log("选中的摄像机数据", this.selectedDeviceInfo);
    },
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D(this.mapInit);
  },
  methods: {
    mapInit() {
      this.queryControlTaskCamera();
    },
    /**
     * 查询摄像机
     * @param controlTypeList  布控分类 1表示人员布控 2表示车辆布控 3周界入侵布控 4消防通道占用布控
     * @param controlFlag  是否布控 1 布控 2 未布控
     * @param deviceName 摄像机名称
     */
    queryControlTaskCamera() {
      this.devices = [];
      this.devicesId = [];
      this.$fetch(api.queryControlTaskCamera, this.deviceForm).then((res) => {
        if (res.success) {
          let checkListPoint = [];
          let listPoint = [];
          if (res.returnObj && res.returnObj.length) {
            res.returnObj.forEach((item) => {
              let azimuth = item.azimuth || 5;
              this.devicesId.push(item.deviceId);
              let info = {
                id: item.deviceId,
                tipsTitle: "摄像机详情",
                showTips: true,
                tipsMap: {
                  deviceName: "摄像机名称",
                  areaName: "所属区域",
                  statusName: "状态",
                  factoryName: "厂家",
                  createrTime: "创建时间",
                },
                attr: {
                  areaName: item.areaName,
                  statusName: item.statusName,
                  factoryName: item.factoryName,
                  createrTime: item.createrTime,
                  deviceName: item.deviceName,
                  controlFlag: item.controlFlag,
                  thirdDeviceId: item.thirdDeviceId,
                  deviceType: "18",
                  areaSetting: { polygons: [], lines: [] },
                  src: `images/theme/newDark/map/${item.statusName == "在线"
                    ? "camera_" + azimuth + ".png"
                    : "camera_gray" + azimuth + ".png"
                    }`,
                  sleSrc: "images/theme/newDark/map/camera-Active.png",
                  oldSrc:
                    item.controlFlag === "2"
                      ? `images/theme/newDark/map/${item.statusName == "在线"
                        ? "camera_" + azimuth + ".png"
                        : "camera_gray" + azimuth + ".png"
                      }`
                      : `images/theme/newDark/map/${item.statusName == "在线"
                        ? "camera_controlled_" + azimuth + ".png"
                        : "camera_controlled_" + azimuth + ".png"
                      }`,
                },
                coord: [Number(item.longitude), Number(item.latitude)],
                src:
                  item.controlFlag === "2"
                    ? `images/theme/newDark/map/${item.statusName == "在线"
                      ? "camera_" + azimuth + ".png"
                      : "camera_gray" + azimuth + ".png"
                    }`
                    : `images/theme/newDark/map/${item.statusName == "在线"
                      ? "camera_controlled_" + azimuth + ".png"
                      : "camera_controlled_" + azimuth + ".png"
                    }`,
                sleSrc:
                  item.controlFlag === "2"
                    ? `images/theme/newDark/map/${item.statusName == "在线"
                      ? "camera_" + azimuth + ".png"
                      : "camera_active" + azimuth + ".png"
                    }`
                    : `images/theme/newDark/map/${item.statusName == "在线"
                      ? "camera_controlled_" + azimuth + ".png"
                      : "camera_controlled_" + azimuth + ".png"
                    }`,
                scale: 1,
              };
              this.devices.push(info);
              // if (item.controlFlag == "1") {
              listPoint.push(info);
              // }
            });
          }
          //地图绘制所有控摄像机
          this.$map.MapInstance2D.addMarket(
            listPoint,
            this.cameraId,
            this.handleClickPoint
          );
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 编辑模式下选中摄像机
    handleClickPoint(data) {
      // console.log(data);
      if (!this.rightShow) {
        return;
      }
      let ids = data.marker.id.split("-")[1];
      if (this.selectedDeviceId.indexOf(ids) !== -1) {
        // 已存在再次点击则取消选中摄像机
        this.selectedDeviceId.splice(this.selectedDeviceId.indexOf(ids), 1);
        this.$map.MapInstance2D.updateFeatureById(
          data.layerId,
          data.marker.id,
          {
            src: data.marker.attr.oldSrc, //选中前摄像机
          }
        );
      } else {
        // if (
        //   data.marker.src == "images/theme/newDark/map/resource/controlled.png"
        // ) {
        //   return false;
        // }
        this.selectedDeviceId.push(ids);
        this.$map.MapInstance2D.updateFeatureById(
          data.layerId,
          data.marker.id,
          {
            src: data.marker.attr.sleSrc, //选中摄像机
          }
        );
      }
    },
    createTask() {
      this.$refs.right.open(1);
      this.rightShow = true;
    },
    //修改单个布控
    editTask(info) {
      let controlCode = info.controlCode;
      console.log("编辑数据", info);
      console.log("编辑数据", this.checkControlInfo);
      if (this.checkControlInfo) {
        // this.checkControlInfo.cameraList.forEach((el) => {
        this.$map.MapInstance2D.updateFeatureById(
          this.cameraId, //未布控摄像机图层,
          this.cameraId + "-" + this.checkControlInfo.deviceId,
          {
            src: "/images/theme/newDark/map/resource/controlled.png",
          }
        );
        // });
      }
      this.$refs.right.isRightShow = false;
      this.$fetch(api.queryControlTaskDetail, {
        controlCode: controlCode,
      }).then((res) => {
        if (res.success) {
          this.checkControlInfo = { ...res.returnObj };
          //   res.returnObj.cameraList.forEach((el) => {
          this.$map.MapInstance2D.updateFeatureById(
            this.cameraId, //未布控摄像机图层,
            this.cameraId + "-" + res.returnObj.deviceId,
            {
              src: "/images/theme/newDark/map/camera-Active.png",
            }
          );
          //   });
          setTimeout(() => {
            this.$refs.right.open(2, res.returnObj);
            this.rightShow = true;
          }, 500);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 编辑成功
    saveSuccess() {
      this.$refs.left.queryList();
      this.queryControlTaskCamera();
    },
    closeRight() {
      this.rightShow = false;
      this.$refs.left.showAdd = true;
      this.$refs.left.activeInfo = null;
      this.queryControlTaskCamera();
      this.selectedDeviceId = [];
    },
    // 查看布控详情
    openDetail(item) {
      if (this.checkControlInfo) {
        // this.checkControlInfo.cameraList.forEach((el) => {
        this.$map.MapInstance2D.updateFeatureById(
          this.cameraId, //未布控摄像机图层,
          this.cameraId + "-" + this.checkControlInfo.deviceId,
          {
            src: "/images/theme/newDark/map/resource/controlled.png",
          }
        );
        // });
      }
      this.checkControlInfo = { ...item };
      console.log("布控详情", item);
      this.$refs.right.isRightShow = false;
      // 显示改任务布控的摄像机
      //   item.cameraList.forEach((el) => {
      this.$map.MapInstance2D.updateFeatureById(
        this.cameraId, //未布控摄像机图层,
        this.cameraId + "-" + item.deviceId,
        {
          src: "/images/theme/newDark/map/resource/controlled_choose.png",
        }
      );
      //   });
      setTimeout(() => {
        this.$refs.right.open(3, item);
      }, 400);
    },
    //删除布控任务
    deleteList() {
      this.queryControlTaskCamera();
      this.closeRight();
    },
    // 勾选/取消树设备 地图同步打点
    chooseCamera(cameraIdList) {
      // 利用cameraId 回显摄像机详细信息
      this.selectedDeviceId = [...cameraIdList];
    },
    // 删除摄像机时 同步取消选中
    deleteCamera(ind) {
      this.selectedDeviceId.splice(ind, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../style/manage.scss";
</style>